var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-result"},[_c('img',{attrs:{"src":require('@/assets/query-service/no-content.svg'),"alt":""}}),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"desc"},[_c('span',[_vm._v(" 1.您所输入的委托单编号有误。 ")]),_c('span',[_vm._v(" 2.若核实无误，请您耐心等待，数据、图片正在更新中，一般更新时间为15-20天。由于本系统的查询量较大，有部分查询可能会出现没有相关资料的信息，此时烦请您在线留言工作人员帮你查询,本中心对委托查询系统具有最终解释权。 ")])])
}]

export { render, staticRenderFns }